module.exports = __webpack_public_path__ + "static/media/4.3ec4a76b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/Tutorial/screenshots/Managing/4.jpg
// module id = 1638
// module chunks = 0